import { em, rem } from 'polished'
import styled from 'styled-components'

interface ICommentStyledProps {}

export const CommentStyled = styled.div<ICommentStyledProps>`
  font-size: ${rem(16)};

  width: ${em(450)};
`
